export enum CoedStatuses {
  Male = 'boys',
  Female = 'girls',
  CoEd = 'coed',
}
